"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Track = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _RegionViewer = require("./RegionViewer");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var OuterWrapper = _styledComponents.default.div.withConfig({
  displayName: "Track__OuterWrapper",
  componentId: "sc-1sdyh2h-0"
})(["display:flex;flex-direction:column;"]);

var InnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "Track__InnerWrapper",
  componentId: "sc-1sdyh2h-1"
})(["display:flex;flex-direction:row;align-items:stretch;"]);

var TopPanel = _styledComponents.default.div.withConfig({
  displayName: "Track__TopPanel",
  componentId: "sc-1sdyh2h-2"
})(["display:flex;"]);

var SidePanel = _styledComponents.default.div.withConfig({
  displayName: "Track__SidePanel",
  componentId: "sc-1sdyh2h-3"
})(["display:flex;flex-shrink:0;flex-direction:column;"]);

var CenterPanel = _styledComponents.default.div.withConfig({
  displayName: "Track__CenterPanel",
  componentId: "sc-1sdyh2h-4"
})(["display:flex;flex-shrink:0;flex-direction:column;"]);

var TitlePanel = _styledComponents.default.div.withConfig({
  displayName: "Track__TitlePanel",
  componentId: "sc-1sdyh2h-5"
})(["display:flex;flex-direction:column;justify-content:center;height:100%;"]); // eslint-disable-next-line react/prop-types


var defaultRenderLeftPanel = function defaultRenderLeftPanel(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title;
  return /*#__PURE__*/_react.default.createElement(TitlePanel, null, title.split('\n').map(function (s) {
    return /*#__PURE__*/_react.default.createElement("span", {
      key: s
    }, s);
  }));
};

var Track = function Track(_ref2) {
  var children = _ref2.children,
      renderLeftPanel = _ref2.renderLeftPanel,
      renderRightPanel = _ref2.renderRightPanel,
      renderTopPanel = _ref2.renderTopPanel,
      rest = _objectWithoutProperties(_ref2, ["children", "renderLeftPanel", "renderRightPanel", "renderTopPanel"]);

  return /*#__PURE__*/_react.default.createElement(_RegionViewer.RegionViewerContext.Consumer, null, function (_ref3) {
    var centerPanelWidth = _ref3.centerPanelWidth,
        isPositionDefined = _ref3.isPositionDefined,
        leftPanelWidth = _ref3.leftPanelWidth,
        regions = _ref3.regions,
        rightPanelWidth = _ref3.rightPanelWidth,
        scalePosition = _ref3.scalePosition;
    return /*#__PURE__*/_react.default.createElement(OuterWrapper, null, renderTopPanel && /*#__PURE__*/_react.default.createElement(TopPanel, {
      style: {
        width: centerPanelWidth,
        marginLeft: leftPanelWidth,
        marginRight: rightPanelWidth
      }
    }, renderTopPanel(_objectSpread(_objectSpread({}, rest), {}, {
      width: centerPanelWidth
    }))), /*#__PURE__*/_react.default.createElement(InnerWrapper, null, /*#__PURE__*/_react.default.createElement(SidePanel, {
      style: {
        width: leftPanelWidth
      }
    }, renderLeftPanel && renderLeftPanel(_objectSpread(_objectSpread({}, rest), {}, {
      width: leftPanelWidth
    }))), /*#__PURE__*/_react.default.createElement(CenterPanel, {
      style: {
        width: centerPanelWidth
      }
    }, children(_objectSpread(_objectSpread({}, rest), {}, {
      isPositionDefined: isPositionDefined,
      leftPanelWidth: leftPanelWidth,
      regions: regions,
      rightPanelWidth: rightPanelWidth,
      scalePosition: scalePosition,
      width: centerPanelWidth
    }))), renderRightPanel && /*#__PURE__*/_react.default.createElement(SidePanel, {
      style: {
        width: rightPanelWidth
      }
    }, renderRightPanel(_objectSpread(_objectSpread({}, rest), {}, {
      width: rightPanelWidth
    })))));
  });
};

exports.Track = Track;
Track.propTypes = {
  children: _propTypes.default.func.isRequired,
  renderLeftPanel: _propTypes.default.func,
  renderRightPanel: _propTypes.default.func,
  renderTopPanel: _propTypes.default.func
};
Track.defaultProps = {
  renderLeftPanel: defaultRenderLeftPanel,
  renderRightPanel: null,
  renderTopPanel: null
};